module.exports = __webpack_public_path__ + "static/media/Aldsworth Kitchen (9).02bd85e2.JPG";